module.exports = __webpack_public_path__ + "static/media/image17.252ad920.png";